import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts/fonts.css';
import App from './App';
import { TvSlideshow } from './components/features/tv/TvSlideshow';

const TV_ROUTE_PATH = '/tv';

const normalizeRoutePath = (pathname: string): string => {
    const lower = pathname.toLowerCase();
    return lower.length > 1 && lower.endsWith('/') ? lower.slice(0, -1) : lower;
};

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Failed to find the root element');
}

const isTvRoute = normalizeRoutePath(window.location.pathname) === TV_ROUTE_PATH;

const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        {isTvRoute ? <TvSlideshow /> : <App />}
    </React.StrictMode>
);
